import GlobalMetricCards from "../../../../../global/GlobalMetricCards";

export default function ParticipantsListMetricsSection({ items, loading }) {
  return (
    <section className="vml-metrics">
      <GlobalMetricCards
        items={items}
        loading={loading}
        ariaLabel="Tournament participant metrics"
      />
    </section>
  );
}
